import { INavData } from '@coreui/angular';
export const navAdmin: INavData[] = [
    
    
  {
    title: true,
    name: 'Section gestion'
  },
    {
        name: 'Gestion des utilisateurs',
        url: '/clients',
        icon: 'icon-people',
      },

  {
    name: 'Gestion des abonnements',
    url: '/e-commerce/orders',
    icon: 'icon-credit-card',
  },
  
 {
  name: 'Gestion des Alerts',
  url: '/alerts',
  icon: 'icon-chart',
},

  {
    name: 'Gestion des OPCVM',
    url: '/opcvmss',
    icon: 'icon-chart',
  },
/*
  {
    title: true,
    name: 'Section Visualisation'
  },

  {
    name: 'Suivi des clients',
    url: '/dashboard/dashboardclients',
    icon: 'icon-target',

  },

  {
    name: 'Suivi de revenu',
    url: '/dashboards/dashboardsales',
    icon: 'icon-wallet',
  },

  {
    name: 'Analyse des profils',
    url: '/profiles/analizeclients',
    icon: 'icon-magnifier',
  },
 */

];
